























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSProductSelector from './AMSProductSelector.vue';
import AMSProductImg from './AMSProductImg.vue';
import AMSSearchProduct from './AMSSearchProduct.vue';
import request from '@/utils/request';
@Component({
  name: 'ams-selected-product',
  components: {
    'ams-product-selector': AMSProductSelector,
    'ams-product-img': AMSProductImg,
    'ams-search-product': AMSSearchProduct
  }
})
export default class AMSSelectedProduct extends Vue {
  /**props */
  @Prop({
    default: () => {
      return [];
    }
  })
  items!: Array<any>;
  /* 过滤掉已选择的商品 */
  /**props */ @Prop({
    default: () => {
      return [];
    }
  })
  selectedItems!: Array<any>;
  @Prop({ default: false }) isMoreBtn!: boolean;
  @Prop({ default: null }) isHidden!: boolean;//搜索商品过滤隐藏商品
  @Prop({ default: false }) isOnSale!: boolean;
  @Prop({ default: false }) isClearable!: boolean;
  @Prop({ default: false }) isNestType!: boolean;//product对象在里层
  /**数据 */
  param: Array<any> = this.items;

  get selectedProducts() {
    return this.selectedItems.filter(s => {
      if (s.id) {
        return s;
      }
    });
  }
  autoComplete(value: any) {
    let product = Object.assign({}, value, { quantity: '1' });
    this.$emit('autoComplete', product);
  }
  selectedProduct(value: any) {
    let selected = value.map((v: any) => {
      return Object.assign({}, v, { quantity: '1' });
    });
    this.$emit('select', selected);
  }
  clear() {
    this.$emit('clear');
  }
  @Watch('items')
  valueChange(newValue: any) {
    this.param = newValue;
  }
}
